import { Vertical, Box } from '@origin-digital/layout';
import { Text, Button, Heading4 } from '@origin-digital/style-guide';
import { CardsContainer, GreenTickCard, CardLinks } from '@origin-digital/card';
import { Card } from '@origin-digital/layout';
import styled from 'styled-components';

import React from 'react';
import analytics from '../../../../analytics';

import { ResponsiveGutters } from '../../../../components/ResponsiveLayout';

import { ThankYouProps } from './ThankYou.types';

const TestimonialImage = styled.div`
  min-width: 64px;
  max-width: 64px;
  height: 64px;
  border-radius: 64px;
  overflow: hidden;
  margin-right: 24px;
`;

export default class ThankYou extends React.Component<ThankYouProps> {
  componentDidMount() {
    analytics.pageLoad('thankyou');
    window.scrollTo(0, 0);
  }

  viewMoreSolarStories() {
    const { data } = this.props;
    window.location.href = data.content.testimonials.buttonHref;
  }

  render() {
    const { data } = this.props;

    return (
      <ResponsiveGutters>
        <Vertical horizontalAlign={'center'} isCardContainer layoutSize={'compact'}>
          <CardsContainer>
            <Box marginBottom={3}>
              <GreenTickCard
                message={data.content.thankyou.heading}
                subtext={data.content.thankyou.text}
              />
            </Box>
            <Box marginBottom={3}>
              <Card>
                <Vertical horizontalAlign={'center'}>
                  <Box alignContent={'center'}>
                    <Heading4 text={data.content.testimonials.heading}></Heading4>
                  </Box>
                  <Box maxWidth="100%" display={'flex'} alignItems={'flex-start'}>
                    <TestimonialImage>
                      <img
                        src="https://res.cloudinary.com/originenergy/image/upload/v1559519553/solar/solar-testimonial_gale.png"
                        width={64}
                        height={64}
                      />
                    </TestimonialImage>
                    <Box width="100%">
                      <Text overflow="normal" size={'sm'} italic={true}>
                        {data.content.testimonials.quote1}
                      </Text>
                      <Text overflow="normal" color={'grey48'} size={'xs'}>
                        {data.content.testimonials.subtext1}
                      </Text>
                    </Box>
                  </Box>
                  <Box maxWidth="100%" display={'flex'} alignItems={'flex-start'}>
                    <TestimonialImage>
                      <img
                        src="https://res.cloudinary.com/originenergy/image/upload/v1559519554/solar/solar-testimonial_james.png"
                        width={64}
                        height={64}
                      />
                    </TestimonialImage>
                    <Box width="100%">
                      <Text overflow="normal" size={'sm'} italic={true}>
                        {data.content.testimonials.quote2}
                      </Text>
                      <Text overflow="normal" color={'grey48'} size={'xs'}>
                        {data.content.testimonials.subtext2}
                      </Text>
                    </Box>
                  </Box>
                  <Button
                    text={data.content.testimonials.buttonText}
                    type={'button'}
                    block={true}
                    kind={'secondary'}
                    onClick={() => this.viewMoreSolarStories()}
                  />
                </Vertical>
              </Card>
            </Box>
            <Card>
              <CardLinks
                links={[
                  {
                    href: data.content.thankyou.href,
                    text: data.content.thankyou.buttonText,
                    'data-id': 'auth-solar-auth-quote:return-to-my-account'
                  }
                ]}
              />
            </Card>
          </CardsContainer>
        </Vertical>
      </ResponsiveGutters>
    );
  }
}
